"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const generateNotFoundOption = (label = 'Not found') => ({
    value: Math.random(),
    label,
});
exports.default = generateNotFoundOption;
